"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggle = void 0;

var _when = require("../when/when");

var _any = require("../any/any");

var _remove = require("../remove/remove");

var _push = require("../push/push");

/**
 * Add element if not exists, remove otherwise
 *
 * @param  {mixed}  element  Toggable value
 *
 * @return {Array}
 *
 * @tag Array
 * @signature (element: mixed) => (source: Array): Array
 *
 * @example
 * toggle(1)([1, 2])
 * // => [2]
 *
 * toggle(1)([2])
 * // => [1, 2]
 */
var toggle = function toggle(element) {
  return function (source) {
    if (source.length === 0) {
      return [element];
    }

    return (0, _when.when)((0, _any.any)(element), (0, _remove.remove)(element), (0, _push.push)(element))(source);
  };
};

exports.toggle = toggle;